import { render, staticRenderFns } from "./Contragents.vue?vue&type=template&id=215b6d0b&"
import script from "./Contragents.vue?vue&type=script&lang=js&"
export * from "./Contragents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports